(function () {
  function setOneTimeDefault(container) {
    if (!container) return false;

    var oneTime = container.querySelector('input.loop-one-time-purchase-option-radio[data-id="loop-one-time-purchase"]');
    if (!oneTime) return false;

    // If a subscription option is selected, switch to one-time
    if (!oneTime.checked) {
      oneTime.checked = true;
      oneTime.dispatchEvent(new Event("change", { bubbles: true }));
    }

    // Clear selling plan input so Shopify treats it as one-time
    var sellingPlan = container.querySelector('input[name="selling_plan"]');
    if (sellingPlan && sellingPlan.value) {
      sellingPlan.value = "";
      sellingPlan.dispatchEvent(new Event("change", { bubbles: true }));
    }

    return true;
  }

  function init() {
    document.querySelectorAll('[id^="loop-subscription-container-"]').forEach(function (container) {
      // Try now
      if (setOneTimeDefault(container)) return;

      // Try again when Loop re-renders (variant changes etc.)
      var obs = new MutationObserver(function () {
        if (setOneTimeDefault(container)) obs.disconnect();
      });
      obs.observe(container, { childList: true, subtree: true, attributes: true });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
